module.exports = __webpack_public_path__ + "static/media/x-circle-white.16a9eb1d.svg";